import { useTranslation } from 'react-i18next';
import { Button } from '@treezor/design-system';

import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';
import { useConfirmationDialog } from '@/hooks/useConfirmationModal';

import { createBulkCard, setBulkCardCreationStep } from '@/store/actions/bulkCardCreations.actions';

import { ResumeBulkCardCreation } from '@/features/cards/components/bulkCardCreation/ResumeBulkCardCreation';
import { CardCreationDetailLeftSide } from '@/features/cards/components/bulkCardCreation/CardCreationDetailLeftSide';

export const BulkReviewDetails = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const activeStep = useAppSelector((state) => state.bulkCardCreation.currentStep);
  const bulkCardCreationDraft = useAppSelector((state) => state.bulkCardCreation.bulkCardCreationDraft);

  const toggleConfirmation = () => ConfirmationBulkCardsCreationModal.toggle();

  const manageActionConfirmation = () => {
    if (!bulkCardCreationDraft) return;
    dispatch(
      createBulkCard({
        ...bulkCardCreationDraft,
        ...(bulkCardCreationDraft.batchDeliveryId
          ? { batchDeliveryId: Number(bulkCardCreationDraft.batchDeliveryId) }
          : {}),
      }),
    );
    dispatch(setBulkCardCreationStep(activeStep + 1));
    toggleConfirmation();
  };

  const ConfirmationBulkCardsCreationModal = useConfirmationDialog({
    title: t('pages.cores.warning'),
    description: t('pages.currentProfiles.cards.bulkCards.launch'),
    confirm: { label: t('pages.modal.sure'), color: 'success', action: manageActionConfirmation },
  });

  return (
    <>
      <div className="flex flex-col items-center gap-3">
        <h5 className="typo-h5-bold text-secondary">{t('pages.currentProfiles.cards.bulkCards.review.title')}</h5>
        <span className="typo-body-regular-small text-tertiary w-[400px] text-center">
          {t('pages.currentProfiles.cards.bulkCards.review.subtitle')}
        </span>
      </div>
      <div className="flex justify-between w-[60vw] my-7">
        {bulkCardCreationDraft && (
          <>
            <CardCreationDetailLeftSide bulkCardCreation={bulkCardCreationDraft} />
            <ResumeBulkCardCreation bulkCardCreation={bulkCardCreationDraft} />
          </>
        )}
      </div>
      <div className="flex items-center gap-3">
        <Button
          id="edit-bulk-cards-viewdetail-btn"
          variant="secondary"
          onClick={() => dispatch(setBulkCardCreationStep(0))}
        >
          {t('pages.currentProfiles.cards.bulkCards.edit')}
        </Button>
        <Button id="validate-bulk-cards-viewdetail-btn" onClick={toggleConfirmation}>
          {t('pages.currentProfiles.cards.bulkCards.validate')}
        </Button>
      </div>
      <ConfirmationBulkCardsCreationModal.ConfirmationDialog />
    </>
  );
};
